export { PeopleYouMayKnow } from './PeopleYouMayKnow'
export type { PeopleYouMayKnowProps } from './PeopleYouMayKnow'
